import styled from 'styled-components';

import {FormControl, FormHelperText, Input, Stack, useToast} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import useFeedback from "../../../utils/use_feedback";
import FormContainer from "../../../components/form_container";
import {useSaveClicked} from "../../../store";
import {useSetEmail} from "../../../api/email";

const SwitchHeading = styled.div``;

const EmailSettings = styled(({className}) => {

    const {error, busy, feedbackCh} = useFeedback();
    const [credentials, setCredentials] = useState({
        currentPassword: '',
        emailAddress: '',
    });
    const set = (name) => (value) => setCredentials((credentials) => ({...credentials, [name]: value}));
    const setEmailAddress = useSetEmail(feedbackCh);

    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    try {
                        await setEmailAddress(credentials.currentPassword, credentials.emailAddress);
                        toast({
                            title: "Email changed.",
                            status: 'success',
                            isClosable: true,
                        });
                    } catch {
                        toast({
                            title: "An error occured - incorrect password?",
                            status: 'error',
                            isClosable: true,
                        });
                    }
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Set Email Address" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                    <Stack spacing={5} mb={"20px"}>

                        <FormControl>
                            <SwitchHeading>Confirm Password</SwitchHeading>
                            <Input type="password"
                                   maxLength="64"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   value={credentials.currentPassword}
                                   onChange={(e) => set('currentPassword')(e.currentTarget.value)} />
                            <FormHelperText>Required for security reasons.</FormHelperText>
                        </FormControl>

                    </Stack>

                    <Stack spacing={5} mb={"20px"}>

                        <FormControl>
                            <SwitchHeading>Email Address</SwitchHeading>
                            <Input type="email"
                                   maxLength="250"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   value={credentials.emailAddress}
                                   onChange={(e) => set('emailAddress')(e.currentTarget.value)}
                            />
                            <FormHelperText>Immediately hashed, only used for resets.</FormHelperText>
                        </FormControl>

                    </Stack>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
    padding: 6px 0;
  }
`;

export default EmailSettings;

